export default __webpack_public_path__ + "static/media/nr2.40d6bb45.webp";